import React, { useState } from "react";
import { connect } from "react-redux";

import "./NavigationBar.css";

import { withStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";

import { fetchPreference } from "@safecv/actions/postActions";
import API_CONFIG from "@safecv/src/api-config";
import {
  USER_NAME_SESSION_ATTRIBUTE_NAME,
  ROLE_SESSION_ATTRIBUTE_NAME,
} from "@safecv/shared/appConstant";

import AuthenticationService from "../LoginComponents/AuthenticationService";
import ManagePreferencesModal from "./ManagePreferencesModal";
import PRDownloadModal from "./PRDownloadModal";

import Preferences from "@safecv/assets/Images/preferences.svg";
import export_pr from "@safecv/assets/Images/export_pr.svg";
import logout from "@safecv/assets/Images/logout.svg";

function Profile(props) {
  const StyledMenu = withStyles({
    paper: {
      border: "1px solid #d3d4d5",
      maxWidth: "35%",
      boxshadow: "#303b4a",
    },
  })(Menu);

  const StyledMenuItem = withStyles({
    root: {
      fontFamily: "Lato",
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "14px",
      lineHeight: "16px",
      color: "#5a6065",
      marginRight: "0.5rem",
      "&:hover": {
        color: "#4183c5",
        borderRadius: "8px",
        boxShadow: "#303b4a",
      },
    },
  })(MenuItem);

  const handleClick = (event) => {
    setopenList(event.currentTarget);
  };
  const [openList, setopenList] = useState(null);
  const handleClose = () => {
    setopenList(null);
  };
  const [userName] = useState(
    localStorage.getItem(USER_NAME_SESSION_ATTRIBUTE_NAME)
  );
  const [role] = useState(localStorage.getItem(ROLE_SESSION_ATTRIBUTE_NAME));
  const [PRDownloadModalState, setPRDownloadModalState] = useState(false);
  const [
    ManagePreferencesModalState,
    setManagePreferencesModalState,
  ] = useState(false);
  const openModal = () => {
    setopenList(null);
    setPRDownloadModalState(true);
  };
  const openModalForPrefrences = () => {
    setopenList(null);
    setManagePreferencesModalState(true);
    props.fetchPreference();
  };
  const closeModalForPreferences = () => {
    setManagePreferencesModalState(false);
  };

  const closeModal = () => {
    setPRDownloadModalState(false);
  };
  return (
    <div>
      <button className="signoutbutton" onClick={handleClick}>
        {userName.charAt(0).toUpperCase()}
      </button>
      <StyledMenu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        id="simple-menu"
        anchorEl={openList}
        keepMounted
        open={Boolean(openList)}
        onClose={handleClose}
      >
        <div className="username-role"> {userName} </div>
        <div className="username-role"> {role} </div>
        <hr className="space-profile"></hr>
        <StyledMenuItem onClick={() => openModalForPrefrences()}>
          <img src={Preferences} className="profile" alt="" />
          Preferences
        </StyledMenuItem>

        {API_CONFIG.FEATURE_GT_UPLOAD_ENABLED ? (
          <StyledMenuItem className="profile" onClick={() => openModal()}>
            <img src={export_pr} className="profile" alt="" />
            Export PR
          </StyledMenuItem>
        ) : null}

        <StyledMenuItem onClick={AuthenticationService.logout}>
          <img src={logout} className="profile" alt="" />
          Logout
        </StyledMenuItem>
      </StyledMenu>
      {PRDownloadModalState && (
        <PRDownloadModal
          closeModal={closeModal}
          modalState={PRDownloadModalState}
        />
      )}
      {ManagePreferencesModalState && (
        <ManagePreferencesModal
          closeModalForPreferences={closeModalForPreferences}
          modalState={ManagePreferencesModalState}
          canBeClosed={true}
          canBeSaved={false}
        />
      )}
    </div>
  );
}
const mapStatetoProps = (state) => ({
  preference: state.criteria.preference,
});
const mapDispatchtoProps = (dispatch) => {
  return {
    fetchPreference: (data) => {
      dispatch(fetchPreference(data));
    },
  };
};
export default connect(mapStatetoProps, mapDispatchtoProps)(Profile);
